import { MatBadgeModule } from '@angular/material/badge';
import { MatToolbarModule } from '@angular/material/toolbar';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { NgxsModule } from '@ngxs/store';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { SharedPipesModule } from '../../pipes/shared-pipes.module';
import { ScDialogsModule } from '../sc-dialogs/sc-dialogs.module';
import { ScWidgetModule } from '../sc-widget/sc-widget.module';
import { ScGenericFormModule } from '../sc-generic-form/sc-generic-form.module';
import { ScPopoverModule } from '../sc-popover';
import { ScMaterialTableComponent } from './sc-material-table/sc-material-table.component';
import { ScTableViewComponent } from './sc-table-view.component';
import { ViewState } from './state/view.state';
import { ScViewWrapperContentComponent } from './components/sc-view-wrapper-content/sc-view-wrapper-content.component';
import { ScTableViewFiltersComponent } from './components/sc-table-view-filters/sc-table-view-filters.component';
import { ScImageGridComponent } from './components/sc-image-grid/sc-image-grid.component';
import { ScTableSummaryComponent } from './sc-material-table/sc-table-summary/sc-table-summary.component';
import { ScTableCellComponent } from './sc-material-table/sc-table-cell/sc-table-cell.component';
import { ValueParserPipe } from './sc-material-table/pipes/value-parser.pipe';
import { ParseUrlPipe } from './sc-material-table/pipes/parse-url.pipe';
import { CalculateTableHeight } from './sc-material-table/pipes/calculate-table-height.pipe';
import { ColumnNamePipe } from './sc-material-table/pipes/column-name.pipe';
import { ColClassPipe } from './sc-material-table/pipes/col-class.pipe';
import { ScCrudService } from './sc-crud.service';
import { ScAdvancedFiltersComponent } from './components/sc-table-view-filters/sc-advanced-filters/sc-advanced-filters.component';

export const TABLE_CONFIGURATION = new InjectionToken<string>('table_config');

@NgModule({
  declarations: [
    ScTableViewComponent,
    ScViewWrapperContentComponent,
    ScTableViewFiltersComponent,
    ScImageGridComponent,
    ScMaterialTableComponent,
    ScTableSummaryComponent,
    ScTableCellComponent,
    ValueParserPipe,
    ParseUrlPipe,
    CalculateTableHeight,
    ColumnNamePipe,
    ColClassPipe,
    ScAdvancedFiltersComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatDatepickerModule,
    ScGenericFormModule,
    MatButtonToggleModule,
    MatButtonModule,
    MatMenuModule,
    MatProgressBarModule,
    MatPaginatorModule,
    MatSortModule,
    MatIconModule,
    MatTooltipModule,
    TranslateModule,
    MatCheckboxModule,
    RouterModule,
    PerfectScrollbarModule,
    MatProgressSpinnerModule,
    MatTableModule,
    ScWidgetModule,
    SharedPipesModule,
    NgxsModule.forFeature([ViewState]),
    ScDialogsModule,
    MatToolbarModule,
    ScPopoverModule,
    MatBadgeModule
  ],
  providers: [ColumnNamePipe, CurrencyPipe, ScCrudService],
  exports: [ScTableViewComponent]
})
export class ScTableViewModule {
  static forRoot(env: any): ModuleWithProviders<ScTableViewModule> {
    return {
      ngModule: ScTableViewModule,
      providers: [{ provide: 'env', useValue: env }]
    };
  }
}
